import styled from "styled-components";

export const PropertyBuyersWrapper = styled.div`
  width: 560px;
  margin: auto;
`;
